<app-spinner [show]="showSpinner"></app-spinner>

<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li><a routerLink="/courses">{{coursesText}}</a></li>
                <li>{{course.name}}</li>
            </ul>
            <h2>{{courseDetail}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Courses Details Area -->
<section class="courses-details-area pt-100 pb-70">
    <div class="container">
        <div class="courses-details-header">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="courses-title">
                        <h2>{{course.nameEn}}</h2>
                    </div>

                    <div class="courses-meta">
                        <ul>
                            <li>
                                <i class='bx bx-calendar'></i>
                                <span
                                    *ngIf="course.createdAt">{{course.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</span>
                            </li>
                        </ul>
                    </div>

                </div>

                <div class="col-lg-4">
                    <div class="courses-price">
                        <!-- <div class="courses-review">
                            <div class="review-stars">
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                                <i class='bx bxs-star'></i>
                            </div>
                            <span class="reviews-total d-inline-block">(2 reviews)</span>
                        </div> -->

                        <div class="price">
                            <span class="price-value" *ngIf="course.checkDiscountPrice()">${{course.price}}</span>
                            <span class="price-value show-price">${{course.getShowPrice()}}</span>
                        </div>
                        <a *ngIf="isActiveBuying;else elseBlock" href="javascript:;" (click)="buyCourse()" class="default-btn"><i
                                class='bx bxs-purchase-tag icon-arrow before'></i><span class="label">Buy Course</span><i
                                class="bx bxs-purchase-tag icon-arrow after"></i></a>
                        <ng-template #elseBlock>
                            <a href="javascript:;"  class="default-btn disabled-button"><i
                                class='bx bxs-purchase-tag icon-arrow before'></i><span class="label">Buyed</span></a>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <div class="courses-details-image text-center">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" [src]="sampleVideoUrl" allowfullscreen></iframe>
                    </div>
                </div>

                <div class="courses-details-desc">
                    <div [innerHTML]="htmlContent"></div>
                </div>


            </div>

            <div class="col-lg-4">
                <div class="courses-sidebar-information">
                    <ul>
                        <li>
                            <span><i class='bx bx-group'></i> Students:</span>
                            {{course.studentsCount}}
                        </li>
                        <li>
                            <span><i class='bx bx-time'></i> Duration:</span>
                            {{getCourseLength(course.length)}}
                        </li>
                        <li>
                            <span><i class="bx bx-tachometer"></i> Effort:</span>
                            {{course.effort}}
                        </li>

                        <li>
                            <span><i class='bx bxs-institution'></i> Institution:</span>
                            <a href="#" class="d-inline-block">Cam-Edu</a>
                        </li>
                        <li>
                            <span><i class='bx bx-atom'></i> Quizzes:</span>
                            Yes
                        </li>
                        <li>
                            <span><i class='bx bxs-badge-check'></i> Level:</span>
                            {{course.level}}
                        </li>
                        <li>
                            <span><i class='bx bx-support'></i> Language:</span>
                            {{course.language}}
                        </li>
                        <li>
                            <span><i class='bx bx-text'></i> Resources:</span>
                            Yes
                        </li>
                        <li>
                            <span><i class='bx bx-certification'></i> Certificate:</span>
                            Yes
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
    <div class="container">
        <div class="related-courses">
            <h3>{{relateCourseText}}</h3>

            <div class="row">
                <div class="col-lg-4 col-md-4" *ngFor="let course of relatedCourses">
                    <app-course-item [course]="course" (routeToCourseDetail) = "routeToCourseDetail($event)">
                    </app-course-item>
                </div>
                

            </div>
        </div>
    </div>
</section>
<!-- End Courses Details Area -->

